/**
 * Coordinates cart drawer and cart page DOM updates so stale async fetches
 * cannot overwrite fresher state.
 */
const cartDomSync = {
  drawerGeneration: 0,
  cartPageGeneration: 0,
  drawerAbortController: null,
  cartPageAbortController: null,

  beginDrawerUpdate() {
    this.drawerGeneration += 1;
    this.drawerAbortController?.abort();
    this.drawerAbortController = new AbortController();
    return {
      generation: this.drawerGeneration,
      signal: this.drawerAbortController.signal,
    };
  },

  shouldApplyDrawer(generation) {
    return generation === this.drawerGeneration;
  },

  beginCartPageUpdate() {
    this.cartPageGeneration += 1;
    this.cartPageAbortController?.abort();
    this.cartPageAbortController = new AbortController();
    return {
      generation: this.cartPageGeneration,
      signal: this.cartPageAbortController.signal,
    };
  },

  shouldApplyCartPage(generation) {
    return generation === this.cartPageGeneration;
  },

  applyDrawerSectionHtml(responseText, generation) {
    if (!this.shouldApplyDrawer(generation)) return false;

    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const targetInner = document.querySelector('#CartDrawer .drawer__inner');
    const sourceInner = html.querySelector('#CartDrawer .drawer__inner');

    if (targetInner && sourceInner) {
      targetInner.replaceWith(sourceInner);
    }

    const cartDrawer = document.querySelector('cart-drawer');
    const sourceDrawer = html.querySelector('cart-drawer');

    if (cartDrawer && sourceDrawer) {
      cartDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
    }

    return true;
  },

  applyCartPageHtml(itemsText, footerText, generation, cartItemsElement) {
    if (!this.shouldApplyCartPage(generation)) return false;

    const itemsHtml = new DOMParser().parseFromString(itemsText, 'text/html');
    const footerHtml = new DOMParser().parseFromString(footerText, 'text/html');
    const sourceQty = itemsHtml.querySelector('cart-items');

    if (sourceQty && cartItemsElement) {
      cartItemsElement.innerHTML = sourceQty.innerHTML;
    }

    const progressTarget = document.getElementById('FreeGift-Progress');
    const progressSource = footerHtml.getElementById('FreeGift-Progress');

    if (progressTarget && progressSource) {
      progressTarget.replaceWith(progressSource);
    }

    const cartFooter = document.getElementById('main-cart-footer');
    const sourceFooter = footerHtml.getElementById('main-cart-footer');

    if (cartFooter && sourceFooter) {
      cartFooter.classList.toggle('is-empty', sourceFooter.classList.contains('is-empty'));
    }

    return true;
  },

  async replaceDrawerInner(fetchHtml) {
    const { generation, signal } = this.beginDrawerUpdate();

    try {
      const responseText = await fetchHtml(signal);
      return this.applyDrawerSectionHtml(responseText, generation);
    } catch (error) {
      if (error.name === 'AbortError') return false;
      throw error;
    }
  },

  async replaceCartPage(fetchHtml, cartItemsElement) {
    const { generation, signal } = this.beginCartPageUpdate();

    try {
      const [itemsText, footerText] = await fetchHtml(signal);
      return this.applyCartPageHtml(itemsText, footerText, generation, cartItemsElement);
    } catch (error) {
      if (error.name === 'AbortError') return false;
      throw error;
    }
  },
};
